module.exports = __webpack_public_path__ + "static/media/winning.b641ff35.png";